module.exports = ".box.lock .description {\n  text-align: center;\n  margin: 10px 0;\n  color: #999; }\n"